if (!customElements.get('kana-sample')) customElements.define('kana-sample', class extends HTMLElement {
  connectedCallback() {
    this.controller?.abort(); this.controller = new AbortController();
    const updateProgress = () => {
      const count = [...this.querySelectorAll('[data-sample-field]')].filter(f => f.value.trim()).length;
      const progress = this.querySelector('[data-sample-progress]');
      const number = this.querySelector('[data-sample-count]');
      if (progress) progress.value = count; if (number) number.textContent = String(count);
    };
    this.addEventListener('input', updateProgress, { signal: this.controller.signal });
    updateProgress();
    this.addEventListener('click', e => {
      if (e.target.closest('[data-sample-clear]')) {
        const fields = [...this.querySelectorAll('[data-sample-field]')];
        if (fields.some(f => f.value) && !window.confirm(this.dataset.confirm)) return;
        fields.forEach(f => f.value = ''); updateProgress(); this.querySelector('[data-sample-status]').textContent = this.dataset.cleared;
      }
      if (e.target.closest('[data-sample-print]')) {
        document.querySelectorAll('.kana-print-target').forEach(n => n.classList.remove('kana-print-target'));
        this.querySelector('.kana-sample-sheet').classList.add('kana-print-target');
        this.querySelectorAll('[data-sample-field]').forEach(f => {
          let copy = f.nextElementSibling;
          if (!copy?.classList.contains('kana-print-answer')) { copy = document.createElement('div'); copy.className = 'kana-print-answer'; f.after(copy); }
          copy.textContent = f.value || ' ';
        });
        window.print();
      }
    }, { signal: this.controller.signal });
    window.addEventListener('afterprint', () => this.querySelector('.kana-print-target')?.classList.remove('kana-print-target'), { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
});
